<template>
  <div id="navBox">
    <div class="logo-box">百科数据资源库</div>
    <p hidden class="topIndex">{{ topIndex }}</p>
    <ul class="navList">
      <!-- <li v-for="item in data" :key="item.link" @click="getChild">
        <a :href="item.link">{{ item.name }}</a>
      </li> -->
      <li
        v-for="item in data"
        :key="item.permName"
        @click="getChild"
        :class="item.permName"
      >
        <a :href="item.url">{{ item.permDesc }}</a>
      </li>
    </ul>
    <div class="userMes">
      <a
        href="/Home"
        target="_blank"
        style="display: inline-block; margin-right: 10px; text-decoration: none"
        >发布前台<i style="margin-left: 5px" class="el-icon-monitor"></i
      ></a>
      <a
        href="/countPage"
        style="display: inline-block; margin-right: 10px; text-decoration: none"
        target="_blank"
        >统计<i class="el-icon-s-data"></i
      ></a>
      <span>当前登录：</span>
      <span class="username-button" id="username">郭德纲</span>
    </div>
  </div>
</template>

<script>
import $ from "jquery";
import cookies from "vue-cookies";
export default {
  data() {
    return {
      data: [],
    };
  },
  props: {
    topIndex: String,
  },
  mounted() {
    // 统一验证token
    var that = this;
    if (this.$route.query.key) {
      $.ajax({
        url: "/zyk/api/check/token",
        type: "GET",
        //contentType: 'application/json;charset=utf-8',
        dataType: "json",
        data: { token: this.$route.query.key },
        error: function (xhr) {
          if (xhr.status == 401) {
            window.location.reload();
          }
        },
        success: function (data) {
          console.log(data);
          // cookies.set("userName", data.obj.user.realName);
          cookies.set("token", data.obj.token);
          that.data = JSON.stringify(data.obj.catalog);
          localStorage.setItem("catalog", JSON.stringify(data.obj.catalog));
          $("#username").text(cookies.get("userName"));
        },
      });
    } else {
      this.data = JSON.parse(localStorage.getItem("catalog"));
      $("#username").text(cookies.get("userName"));
    }
    // console.log(JSON.parse(localStorage.getItem("catalog")));
    // this.data = JSON.parse(localStorage.getItem("catalog")).map((item)=>{
    //   return {
    //     name:item.permDesc,
    //     link:item.children[0].permName
    //   }
    // })
    var gettopIndex = $(".topIndex").text();
    setTimeout(function () {
      $.each($(".navList li"), function (index, obj) {
        console.log(index);
        var divClass = $(obj).prop("class");
        if (divClass == gettopIndex) {
          $(obj).addClass("navActive");
          $(obj).siblings().removeClass("navActive");
        }
      });
    }, 300);
  },
  methods: {
    getChild() {
      console.log(this.index);
    },
  },
};
</script>

<style>
/* 导航页css */
#navBox {
  position: fixed;
  width: 100vw;
  height: 90px;
  overflow: hidden;
  top: 0;
  background-color: #fff;
  z-index: 20;
}

#navBox::after {
  content: "";
  display: inline-block;
  clear: both;
}

#navBox .logo-box {
  float: left;
  font-size: 18px;
  font-weight: 700;
  color: #ffffff;
  width: 170px;
  height: 83%;
  line-height: 74px;
  text-align: center;
  display: inline-block;
  background: #36474f;
}

#navBox .navList {
  box-shadow: 1px 7px 7px -4px #cdcdcd;
}

#navBox .navList li {
  line-height: 74px;
  display: inline-block;
  box-sizing: border-box;
  font-size: 16px;
  font-weight: 700;
  padding: 0 30px;
  color: #4c5d65;
}

#navBox .navList li.navActive a,
#navBox .navList li:hover a {
  color: #50b58d;
}

#navBox .userMes {
  position: absolute;
  right: 0;
  top: 0;
  height: 74px;
  font-size: 14px;
  margin-right: 20px;
}

#navBox .userMes span {
  vertical-align: middle;
  line-height: 74px;
}

#navBox .userMes span + span {
  padding-right: 20px;
}

#navBox .userMes a {
  line-height: 74px;
  text-decoration: underline;
  padding-right: 10px;
}
</style>
